module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ashley-poster-f6b3a2335e1407a6b40d8327d49f1761.jpg";